import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodSearchValidator } from '@tanstack/router-zod-adapter';
import z from 'zod';

import { queries } from '../common/api/queryKeys/queries';
import { OfferComparePage } from '../order/detail/OfferComparePage';
import { OfferCompareView } from '../order/detail/OfferCompareView';

const orderDetailSearchSchema = z.object({
    view: fallback(z.enum([OfferCompareView.OVERVIEW, OfferCompareView.LINE_ITEMS]), OfferCompareView.OVERVIEW).default(
        OfferCompareView.OVERVIEW
    ),
});

export const Route = createFileRoute('/_app/order/$id')({
    validateSearch: zodSearchValidator(orderDetailSearchSchema),
    async loader({ params, context }) {
        context.queryClient.ensureQueryData(queries.orders.detail(params.id));
        context.queryClient.prefetchQuery(queries.offers.list({ orderIds: [params.id] }));
    },
    component: OfferComparePage,
});
